import { Color } from "./color";
import { themes } from "./theme-impl";

export interface themeVariantInterface {
  LIGHT: string;
  DARK: string;
}

export const themeVariant = {
  LIGHT: "Light",
  DARK: "Dark",
} as themeVariantInterface;

export const getTheme = (selectedTheme: string, themePrimaryColor?: Color, direction?: any) => {
  switch (selectedTheme) {
    case themeVariant.LIGHT:
      return themes.createLightTheme(themePrimaryColor, direction);
    case themeVariant.DARK:
      return themes.createDarkTheme(themePrimaryColor);
    default:
      return themes.createLightTheme(themePrimaryColor, direction);
  }
};

export default themeVariant;
